<template>
  <FormInput :label-for="labelFor" :label-text="labelText"
             :show-error="showError" :error-text="errorText"
             :required="required" :smallInput="smallInput"
  >
    <div style="display: flex; align-items: center">
      <input @change="updateInput" v-model="value"
             @focus="handleFocus" @blur="handleBlur"
             :id="labelFor" type="text" :required="required"
             :maxlength="maxLength"
             :class="['relative', { 'error': hasError, 'max-length-padding': showMaxLength }]">
      <span v-if="showMaxLength"
            :class="['max-length', {'maximum' : maxLength - value.length === 0}]"
      >{{ maxLength - value.length }}</span>
    </div>
  </FormInput>
</template>
<script>
import FormInput from "./FormInput.vue";

export default {
  components: {FormInput},
  props: {
    labelFor: {
      type: String,
      required: true,
    },
    labelText: {
      type: String,
      required: true,
    },
    inputValue: {
      required: true,
    },
    showError: {
      type: Boolean,
      default: false,
    },
    errorText: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
    smallInput: {
      type: Boolean,
      default: false,
    },
    maxLength: {
      type: String,
      required: false,
    }
  },
  emits: ['change'],
  data() {
    return {
      value: this.inputValue,
      inputFocused: false,
    }
  },
  computed: {
    hasError() {
      return this.showError && this.errorText.length > 0;
    },
    showMaxLength() {
      if (!this.inputFocused || !this.maxLength || !this.value) return false
      let maxInt = parseInt(this.maxLength);
      if (maxInt < 20) return this.maxLength - this.value.length <= 5;
      if (maxInt < 50) return this.maxLength - this.value.length <= 10;
      if (maxInt < 100) return this.maxLength - this.value.length <= 15;
      return this.maxLength - this.value.length <= 25;
    }
  },
  methods: {
    updateInput() {
      this.$emit('change', {value: this.value});
    },
    handleFocus() {
      this.inputFocused = true;
    },
    handleBlur() {
      this.inputFocused = false;
    }
  }
}
</script>
<style scoped>

.form-input {
  font: var(--bold-16-20);
  line-height: 28px;
  margin-bottom: 15px;
}

.form-input input {
  padding: 8px;
  opacity: 1;
}

.form-input input:focus {
  outline-color: var(--brown);
}

label.error {
  color: red;
}

input.error {
  border: 1px solid red !important;
}

input.error:focus {
  outline-color: red;
}

.max-length {
  position: absolute;
  right: 10px;
  font-size: 16px;
  background-color: var(--brown);
  color: white;
  border-radius: 6px;
  width: 28px;
  height: 28px;
  text-align: center;
}

.maximum {
  background-color: red;
}

.relative {
  position: relative;
}

.max-length-padding {
  padding-right: 45px !important;
}

</style>